<div
  *ngIf="spinner"
  style="
    width: 100vw;
    height: 100vh;
    background-color: rgba(105, 105, 105, 0.5);
    display: flex;
    overflow: hidden;
    z-index: 999999;
    position: fixed;
    top: 0;
  "
>
  <div style="margin: auto"><p-progressSpinner></p-progressSpinner></div>
</div>
<p-toast key="tst"></p-toast>
<p-toast></p-toast>
<router-outlet></router-outlet>
